import { Grid, IconButton } from '@material-ui/core';
import React, { memo, useEffect, useMemo, useState } from 'react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import style from '../NewPatient/NewPatientsTabs.module.css';
import { useLang } from '../../util/lang';
import { useSelector } from 'react-redux';
import { smileDesignProductListArray } from '../../store/SmileDesign/SmileDesignSlice';
import { WORKFLOW_TAB } from '../NewPatient/NewPatientUtill';

const CustomBadge = ({ showBadge = false }) => {
    if (!showBadge) return null;
    return <span className={style.CustomBadge}>*</span>;
};

const WorkFlowTab = ({ handleChangeTabLocal, props, name, tab, lang, Icon, showArrow = true }) => {
    const { classes, NewCaseType, tabMode } = props;
    const get = useLang();
    const [showSmileDesignBadge, setShowSmileDesignBadge] = useState(true);
    const { smileDesignPrescriptionFormIsValid } = useSelector((state) => state.smileDesign);
    const newPatientReducer = useSelector((state) => state.newPatientReducer);
    const { errors } = newPatientReducer;

    useEffect(() => {
        if (tab === WORKFLOW_TAB.PRESCRIPTION_NOTES && smileDesignProductListArray.includes(NewCaseType)) {
            setShowSmileDesignBadge(!smileDesignPrescriptionFormIsValid);
        }
    }, [smileDesignPrescriptionFormIsValid, tab]);

    const isShowBadge = useMemo(() => {
        let error = undefined;
        if (errors && Array.isArray(errors)) {
            error = errors.find((v) => v.id === name);
        }
        const isError = error && !error.valid;
        const isSmileDesignBadge =
            smileDesignProductListArray.includes(NewCaseType) &&
            tab === WORKFLOW_TAB.PRESCRIPTION_NOTES &&
            showSmileDesignBadge;
        return isError || isSmileDesignBadge;
    }, [errors, showSmileDesignBadge, tab, NewCaseType, name]);

    return (
        <Grid item style={{ textAlign: 'center', display: 'flex' }}>
            <div className={style.iconButtonContainer} onClick={() => handleChangeTabLocal(tab)}>
                <div className={style.CustomBadgeContainer}>
                    <CustomBadge showBadge={isShowBadge} />
                    <IconButton
                        aria-label="delete"
                        style={{
                            background: tabMode === tab ? '#2eafb6' : '#bababa',
                        }}
                        className={style.iconButton}
                    >
                        <Icon />
                    </IconButton>
                </div>

                <p className={tabMode === tab ? classes.tabTextActive : classes.tabText}>{get(lang)}</p>
            </div>
            {showArrow && (
                <div className={style.iconButtonArrowContainer}>
                    <IconButton aria-label="delete" disabled className="iconButtonArrow">
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </div>
            )}
        </Grid>
    );
};

export default memo(WorkFlowTab);
